import { EyeOutlined } from '@ant-design/icons';
import type { Product } from '@shop-monorepo/types';
import { Button, Tag } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { formatPrice } from '../utils/currency';

import { DeleteButton } from './DeleteButton';
import { EditButton } from './EditButton';

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 8px;
`;

const CardImage = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: #edf2f7;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CardName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CardMeta = styled.div`
  font-size: 13px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

const CardActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
`;

interface ProductMobileCardProps {
  product: Product;
  brandName?: string;
  onView: (slug: string) => void;
  onEdit: (slug: string) => void;
  onDelete: (id: number) => void;
}

export const ProductMobileCard: React.FC<ProductMobileCardProps> = ({
  product,
  brandName,
  onView,
  onEdit,
  onDelete,
}) => (
  <Card>
    <CardImage>{product.image && <img src={product.image} alt={product.name} />}</CardImage>
    <CardBody>
      <CardName>{product.name}</CardName>
      <CardMeta>
        <span style={{ fontWeight: 700, color: '#1a1a1a' }}>{formatPrice(product.price)}</span>
        {brandName && <span>· {brandName}</span>}
      </CardMeta>
      <CardMeta>
        {product.isActive ? (
          <Tag color="green" style={{ margin: 0 }}>
            Активний
          </Tag>
        ) : (
          <Tag style={{ margin: 0 }}>Неактивний</Tag>
        )}
        {product.isNew && (
          <Tag color="blue" style={{ margin: 0 }}>
            Новий
          </Tag>
        )}
      </CardMeta>
    </CardBody>
    <CardActions>
      <Button icon={<EyeOutlined />} onClick={() => onView(product.slug)} />
      <EditButton onClick={() => onEdit(product.slug)} />
      <DeleteButton onConfirm={() => onDelete(product.id)} entityName={product.name} />
    </CardActions>
  </Card>
);
